<template>
  <download-center />
</template>

<script>
import DownloadCenter from './DownloadCenter'

export default {
  name: 'DownloadRoot',
  components: { DownloadCenter }
}
</script>

<style>
html,
body,
#download-app {
  width: 100%;
  min-height: 100%;
  margin: 0;
  background: #000;
}

body {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/download/DownloadRoot.vue